// HeaderExample.js
import React, { useContext, useEffect, useRef, useState } from 'react';
import {
  Box,
  Button,
  Header,
  ResponsiveContext,
  Text,
} from 'grommet';
import Search from './Search';
import UploadButton from './Upload/UploadButton';
import Profile from './Profile';
import { Menu } from 'grommet-icons';

const HeaderExample = ({
  setView,
  loggedIn,
  setLoggedIn,
  setShowMenuLayer,
  user
}) => {
  const size = useContext(ResponsiveContext);
  const [focused, setFocused] = useState(false);
  const inputRef = useRef();

  useEffect(() => {
    if (focused && inputRef.current) {
      inputRef.current.focus();
    }
  }, [focused, setFocused]);

  return (
    <Header
      fill="horizontal"
      pad={{ horizontal: !['xsmall', 'small'].includes(size) ? 'medium' : 'small', vertical: 'small' }}
      border={{ side: 'bottom' }}
      justify='between'
      style={{position: 'sticky', top: 0 }}
    >
      <Box direction='row' gap='medium'>
        <Button
          a11yTitle='Open menu'
          icon={<Menu />}
          onClick={() => setShowMenuLayer(true)}
        />
        <Button onClick={() => setView('feed')}>
          <Text color="text-strong" weight="bold" size="xlarge">claim3</Text>
        </Button>
      </Box>
      <Search />
      { loggedIn && (
        <Box direction='row' gap="medium" align='center'>
          <UploadButton setView={setView}/>
          <Profile
            setLoggedIn={setLoggedIn}
            setView={setView}
            user={user}
          />
        </Box> 
      )}
      { !loggedIn && (
        <Box direction="row">
          <Button label="Sign in" onClick={() => setView('signIn')}/>
        </Box>
      )}
    </Header>
  );
};

export default HeaderExample;